module.exports = __webpack_public_path__ + "fonts/tt_sushkof_bold.5bdebb9.ttf";